module.exports = __webpack_public_path__ + "img/dots-3.0438e299.svg";